// src/app/core/error/global-error.handler.ts
import { ErrorHandler, Injectable, Injector, NgZone, isDevMode, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ErrorLoggerService } from './error-logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private zone = inject(NgZone);

  constructor() {
    console.log('GlobalErrorHandler initialized');
  }

  handleError(err: unknown): void {
    const toast = this.injector.get(MessageService);
    const logger = this.injector.get(ErrorLoggerService);

    let summary = 'Si è verificato un errore';
    let detail: string | undefined;

    if (err instanceof HttpErrorResponse) {
      const s = err.status;
      if (s === 0)        summary = 'Connessione assente o server non raggiungibile';
      else if (s === 403) summary = 'Accesso negato';
      else if (s === 404) summary = 'Risorsa non trovata';
      else if (s >= 500)  summary = 'Errore del server';
      else                summary = err.error?.message || 'Richiesta non valida';
      detail = `HTTP ${s}${err.message ? ` - ${err.message}` : ''}`;
    } else if (err instanceof Error) {
      summary = 'Errore applicativo';
      detail = err.message;
    } else if (typeof err === 'string') {
      summary = 'Errore';
      detail = err;
    }

    logger.log(err);

    // Show toast in the Angular zone
    this.zone.run(() => {
      toast.add({
        severity: 'error',
        summary,
        detail: isDevMode() ? detail : undefined,

      });
    });

  }
}
